// extracted by mini-css-extract-plugin
export var burgerContainer = "HeaderNavTablet-module--burgerContainer--f5f6a";
export var header = "HeaderNavTablet-module--header--b841f";
export var headerMain = "HeaderNavTablet-module--headerMain--ff1f6";
export var headerSecondary = "HeaderNavTablet-module--headerSecondary--f9918";
export var headerWrapper = "HeaderNavTablet-module--headerWrapper--43686";
export var horizontalSpacer = "HeaderNavTablet-module--horizontalSpacer--cd286";
export var iconHeader = "HeaderNavTablet-module--iconHeader--c9317";
export var iconSecondary = "HeaderNavTablet-module--iconSecondary--97006";
export var languageChevronDown = "HeaderNavTablet-module--languageChevronDown--76262";
export var languageOrSearch = "HeaderNavTablet-module--languageOrSearch--8226a";
export var languageOrSearchScroller = "HeaderNavTablet-module--languageOrSearchScroller--c6a94";
export var languageSwitch = "HeaderNavTablet-module--languageSwitch--3339b";
export var languageSwitchFlag = "HeaderNavTablet-module--languageSwitchFlag--dbc22";
export var secondaryTitle = "HeaderNavTablet-module--secondaryTitle--54683";